export * from './linked-accounts-granted-table.component';
